import * as React from 'react';
import { ArticleParagraph1, ModalWindow, UIHeading2 } from '@cian/ui-kit';

import * as styles from './ProjectModalMobile.css';
import { IProjectModalBaseProps } from '../../types';
import { ProjectPrice } from '../../../ProjectPrice';
import { ProjectParameters } from '../../../ProjectParameters';

export type IProjectModalMobileProps = IProjectModalBaseProps;

export const ProjectModalMobile: React.FC<IProjectModalMobileProps> = ({
  slider,
  onClose,
  phoneButton,
  name,
  startPrice,
  area,
  floors,
  materials,
  description,
  callbackButton,
}) => {
  return (
    <ModalWindow
      open
      fixed
      onClose={onClose}
      title={name}
      footer={
        <div className={styles['footer']}>
          {phoneButton}
          {callbackButton}
        </div>
      }
    >
      <div className={styles['body']}>
        {slider}
        <div className={styles['text']}>
          {startPrice && (
            <div className={styles['price']}>
              <UIHeading2>
                <ProjectPrice start={startPrice} />
              </UIHeading2>
            </div>
          )}
          <div className={styles['parameters']}>
            <ArticleParagraph1 as="div">
              <ProjectParameters area={area} floors={floors} materials={materials} />
            </ArticleParagraph1>
          </div>
          <ArticleParagraph1 as="div">{description}</ArticleParagraph1>
        </div>
      </div>
    </ModalWindow>
  );
};
